import type { SearchViewType } from ".";

export enum UserType {
  Free = "free",
  Company = "company",
  Unilogin = "uni-login",
  Wayf = "wayf",
  OIDC = "oidc",
  Private = "private",
  Network = "network",
  SchoolNetwork = "school-network"
}

export type EnterpriseType = "admin" | "dictionary-editor";
export type UniloginFunction = "student" | "teacher";

export interface WriteAssistantPromotion {
  type: "app" | "web";
  url: string;
}

export type OsType = "windows" | "macos";

export interface User {
  username: string;
  companyName: string;
  paying: boolean;
  freeSearchesLeft: number | null;
  credentials: {
    authenticated: boolean;
    ordbogenAccount: boolean;
    type: UserType;
    enterpriseType: EnterpriseType | null;
    uniloginFunction: UniloginFunction | null;
    openNetwork: {
      active: boolean;
      name: string;
    };
  };
  featureFlags: {
    availableSearchViews: SearchViewType[];
    availableWriteAssistantPromotion: WriteAssistantPromotion | null;
    hasLanguageChat: boolean;
    showSearchViewToggle: boolean;
    showPlusLink: boolean;
    showAbcPromotion: boolean;
    showCompanyDictionaryAd: boolean;
  };
  settings: {
    compactArticlesExpanded: boolean;
    preferredSearchView: SearchViewType;
  };
  system: {
    os: OsType;
  };
}
